import { z } from 'zod';
import { allPhases, IDashboardViews } from '../models';
import { zULID } from './submissions';

export const savedFilterValidator = z
  .object({
    workflowPhase: z
      .array(z.enum([allPhases[0]!, ...allPhases.slice(1)]))
      .default([]),
    journalId: z.array(zULID).default([]),
    documentType: z.array(z.string()).default([]),
    assigneeId: z.array(z.string()).default([]),
    searchParams: z.string().default(''),
    name: z.string().min(1, 'Filter name is required'),
    tagId: z.array(z.string()).default([]),
    focusIssueId: z.array(z.string()).default([]),
    view: z.enum([IDashboardViews[0]!, ...IDashboardViews.slice(1)]).optional(),
    expertPhases: z.array(z.string()).default([]),
    advancedSearch: z
      .array(
        z.object({
          field: z.string(),
          // Multi-value fields (keywords, checkbox arrays) send an array, which
          // the backend matches as "any of"; every other field sends a string.
          value: z.union([z.string(), z.array(z.string())])
        })
      )
      .optional()
  })
  .refine(
    data =>
      data.searchParams ||
      data.workflowPhase.length ||
      data.journalId.length ||
      data.documentType.length ||
      data.assigneeId.length ||
      data.tagId.length ||
      data.focusIssueId.length ||
      data.expertPhases.length ||
      data.advancedSearch?.length,
    {
      message: 'At least one filter parameter must be provided.',
      path: [
        'searchParams',
        'workflowPhase',
        'journalId',
        'documentType',
        'assigneeId',
        'tagId',
        'focusIssueId',
        'advancedSearch'
      ]
    }
  );
